import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ItemsCount
*  Объект, содержащий результат с кол-вом элементов, которые удовлетворяют условию запроса
*/
export class ItemsCount extends ActiveModel {

  /**
  * value
  * Кол-во элементов, удовлетворяющих условиям запроса<br>  */
  @ActiveField(0)
  value: number = 0
}
